import React, { FC } from 'react';

import { MAX_CONTENT_WIDTH } from '../../constants';
import { Content, Wrapper } from './styles';

type PropTypes = {
  sidebarWidth?: string;
  contentWidth?: string;
  maxWidth?: string;
};

const Container: FC<PropTypes> = ({
  sidebarWidth = '25%',
  contentWidth = '75%',
  maxWidth = MAX_CONTENT_WIDTH,
  ...props
}) => <Wrapper {...props} sidebarWidth={sidebarWidth} contentWidth={contentWidth} maxWidth={maxWidth} />;

type PageWithSidebarComposition = {
  Container: typeof Container;
  Content: typeof Content;
};

export const PageWithSidebar: PageWithSidebarComposition = {
  Container,
  Content,
};
